import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-light-teal to-soft-teal pt-8 pb-10 md:pt-16 md:pb-16 px-4 overflow-hidden" data-id="element-55">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start text-left z-10" data-id="element-57">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4 leading-tight" data-id="element-58">
            Dile Adiós a los Pañales en solo 72 Horas{' '}
            <span className="text-coral block mt-1" data-id="element-59">(Garantizado)</span>
          </h1>
          <h2 className="text-xl md:text-2xl text-dark-teal/80 font-medium mb-6 leading-relaxed max-w-xl" data-id="element-60">
            El método de "Inmersión Acelerada" diseñado para mamás latinas en
            EE.UU. que necesitan que sus hijos dejen el pañal antes del primer
            día de Daycare o Pre-K.
          </h2>
          <CTAButton className="w-full md:w-auto" data-id="element-61">
            ¡SÍ, QUIERO LA INDEPENDENCIA DE MI HIJO AHORA!
          </CTAButton>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative z-10 flex justify-center md:justify-end" data-id="element-62">
          <div className="relative w-full max-w-md" data-id="element-63">
            <div className="absolute inset-0 bg-white/40 rounded-[2rem] blur-2xl transform rotate-3" data-id="element-64"></div>
            <img src="https://cdn.magicpatterns.com/uploads/su8s666Wys2SEwhR5zaz99/Adios_Panal_en_3_Dias.png" alt="Bebé feliz junto a una tablet mostrando el curso Adiós Pañal en 3 Días" className="relative z-10 rounded-2xl shadow-2xl w-full object-cover border-4 border-white/50" data-id="element-65" />
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-66">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/30 rounded-full blur-3xl" data-id="element-67"></div>
        <div className="absolute bottom-0 right-0 w-[40rem] h-[40rem] bg-white/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-68"></div>
      </div>
    </section>;
}